import dayjs from "dayjs";

// for using fromNow function, plugin is required. see https://day.js.org/docs/en/display/from-now
import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);

export function formattedDateAndTime(milliseconds) {
    return dayjs(milliseconds).format("MMM D, YYYY - HH:mm");
}

export function formattedDate(milliseconds) {
    return dayjs(milliseconds).format("MMM D, YYYY");
}

export function fromNow(milliseconds) {
    return dayjs(milliseconds).fromNow();
}
